import axios from "axios";
import { enqueueSnackbar } from "notistack";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { API } from "../helpers/constants";
import { handleAxiosErrors } from "../helpers/errorHandling";
import { EXHIBITION } from "../locales/components/namespaces";
import useUserData from "./user/useUserData";

export const EmailValid = {
	Valid: 'valid',
	Error: 'error',
	Idle: 'idle',
}

const emailSchema = yup
.string()
.trim()
.email("Invalid email").required()

export const useValidateEmail = () => {
	const { t } = useTranslation(EXHIBITION)
	const { token } = useUserData()
	const [emailIsValid, setEmailIsValid] = useState(EmailValid.Idle)
	const validateEmail = useCallback((email) => {
		const value = email?.trim()
		if (!value) {
			setEmailIsValid(EmailValid.Idle);
			return;
		}
		
		emailSchema.validate(value).then(() => {
			axios({
				url: API + '/en/check-email',
				method: 'post',
				data: {
					email: value,
				},
				headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
			}).then((response) => {
				setEmailIsValid(response.data.check ? EmailValid.Valid : EmailValid.Error)
			}).catch((error) => {
				setEmailIsValid(EmailValid.Error);
				enqueueSnackbar(handleAxiosErrors(error, t('Email validation failed!')), {
					variant: 'warning',
					autoHideDuration: 1000,
				})
			})
		}).catch(() => {
			setEmailIsValid(EmailValid.Idle);
		})
	}, [t, token])
	
	return {
		validateEmail,
		emailIsValid,
		setEmailIsValid
	}
}